module.exports = __webpack_public_path__ + "img/template-circle-2.e60b29c0.png";